import { Map } from 'immutable';

export default Map({
  loading: false,
  data: null,
  error: null,
});
